module.exports = __webpack_public_path__ + "static/media/slide-9.23f1f508.jpg";